import React, { PureComponent } from "react";
import { Field } from "redux-form/immutable";
import Person from "@material-ui/icons/Person";

import { SortableList } from "altus-ui-components";

import { notEmpty, required } from "utils/validation.util";
import { CREATE_VIEW_GROUPS_FORM } from "features/planner/planner.constants";
import AddToSelectedItemsField from "features/planner/components/View/CreateViewGroups/AddToSelectedItemsField";

export default class LocationGroupsList extends PureComponent {
  columns = [
    {
      xs: 5,
      title: "Name",
      getSortProperty: locationGroup => locationGroup.getIn(["name"]),
    },
    {
      xs: true,
      title: "Company",
      getSortProperty: locationGroup => locationGroup.getIn(["companyName"]),
    },
    {
      xs: true,
      title: "Modified by",
      getSortProperty: locationGroup => locationGroup.getIn(["modifiedBy"]),
    },
  ];

  actions = [
    {
      getValue: item => (
        <Field
          itemId={item.get("id")}
          validate={[required, notEmpty]}
          component={AddToSelectedItemsField}
          name={CREATE_VIEW_GROUPS_FORM.SELECTED_ITEMS}
        />
      ),
    },
  ];

  render() {
    const { locationGroups } = this.props;

    return (
      <SortableList
        Icon={Person}
        minItems={10}
        displaySearchField
        items={locationGroups}
        actions={this.actions}
        columns={this.columns}
        getKey={item => item.get("id")}
      />
    );
  }
}
